// @flow
export const PETS_INCLUDED_LEGACY_KEY: {[string]: string} = {
    abritel: 'SpecialOptions:suitability_pets_considered',
    homeaway_us: 'amenities_title:suitability_pets_considered',
    homeaway_uk: 'amenities_title_old:suitability_pets_considered',
    homelidays_es: 'suitability_title:suitability_pets_considered',
    homelidays_fr: 'suitability_title:suitability_pets_considered',
    homelidays_it: 'suitability_title:suitability_pets_considered',
    vrbo: 'amenities_title:suitability_pet_friendly'
};

export const PETS_INCLUDED_LEGACY_LINK: {[string]: string} = {
    abritel: 'Options spéciales:animaux acceptes',
    homeaway_at: 'Ausstattung:Haustiere erlaubt',
    homeaway_de: 'Ausstattung:Haustiere erlaubt',
    homeaway_es: 'Servicios:se admiten mascotas',
    homeaway_gr: 'Χαρακτηριστικά:δέχεται κατοικίδια',
    homeaway_pl: 'Cechy:Przyjazne dla zwierząt',
    homeaway_uk: 'Property Details:pets considered',
    homeaway_us: 'Features:pets considered',
    homelidays_es: 'Opciones especiales:admiten-animales',
    homelidays_fr: 'Options spéciales:animaux-acceptes',
    homelidays_it: 'Caratteristiche speciali:animali-ammessi',
    vrbo: 'Features:pet_friendly'
};

export const PETS_INCLUDED_ID = 'filter:27';

const PETS_INCLUDED_IDS: string[] = [
    ...Object.keys(PETS_INCLUDED_LEGACY_KEY).map(
        (key) => PETS_INCLUDED_LEGACY_KEY[key]
    ),
    ...Object.keys(PETS_INCLUDED_LEGACY_LINK).map(
        (key) => PETS_INCLUDED_LEGACY_LINK[key]
    ),
    PETS_INCLUDED_ID
];

/**
 * Returns true if filter is a pet refinement
 * @param {string} filter filter refinement
 */
export const isPetFilter = (filter: string) =>
    PETS_INCLUDED_IDS.map((id) => id.toLowerCase()).includes(
        decodeURIComponent(filter).toLowerCase()
    );

/**
 * Returns true if filters contain a pet refinement
 * @param {?string[]} filters refinement filters
 */
export const petsInFilters = (filters: Array<string> = []): boolean => {
    return !![].concat(filters).find(isPetFilter);
};

const withoutPetsFilter = (filter: ?(string[])) =>
    [].concat(filter || []).filter((f) => !isPetFilter(f));

export type SyncPetsInput = {
    filter?: string[],
    petIncluded?: boolean
};

/**
 * Value to use as source of truth for syncing
 * both - if either is true, set both to true
 * petIncluded - if petIncluded is true, add the pet refinement, else remove the pet refinement
 * filter - if the filter has pet refinements, set petIncluded to true, else set it to false
 */
export type SyncWithStrategy = 'both' | 'petIncluded' | 'filter';

export const SYNC_STRATEGY_BOTH = 'both';
export const SYNC_STRATEGY_PET_INCLUDED = 'petIncluded';
export const SYNC_STRATEGY_FILTER = 'filter';

/**
 * Takes a search request object and syncs the petIncluded and pet refinement filters
 * @param {T: SyncPetsInput} searchRequest object containing fields from SyncPetsInput
 */
function syncPets<T: SyncPetsInput>(
    searchRequest: T,
    syncWith: SyncWithStrategy = 'both'
): T {
    const filter = [].concat(searchRequest.filter || []);
    const withoutPets = withoutPetsFilter(filter);
    const petsInFilter = withoutPets.length !== filter.length;

    if (syncWith === 'both') {
        if (petsInFilter !== !!searchRequest.petIncluded) {
            if (!petsInFilter) {
                searchRequest.filter = [
                    ...withoutPets,
                    PETS_INCLUDED_ID
                ].sort();
            }
            searchRequest.petIncluded = true;
        }
    } else if (syncWith === 'filter') {
        // use filter as source of true
        searchRequest.petIncluded = petsInFilter;
    } else if (syncWith === 'petIncluded') {
        // use petIncluded as source of true
        if (searchRequest.petIncluded) {
            searchRequest.filter = [...withoutPets, PETS_INCLUDED_ID].sort();
        } else if (petsInFilter) {
            // petIncluded flag not set, but there's pets in the filter field
            searchRequest.filter = withoutPets;
        }
    }

    return searchRequest;
}

export default syncPets;
